<app-dropdown #dropdown [componentWithDataSetter]="panelConfig" [widthInPX]="'220px'" [heightInPX]="0" [exceptionSelector]="'.flag-dropdown-panel'">
  <button type="button" class="tw-relative tw-inline-flex tw-items-center tw-justify-center tw-p-1 tw-rounded tw-cursor-pointer !tw-bg-transparent !tw-border-0">
    <i
      [ngClass]="{
        fas: flagColor,
        far: !flagColor,
        'tw-text-gray-300': !flagColor
      }"
      class="fa-flag tw-text-sm"
      [style.color]="flagColor === 'red' ? '#d32f2f' : flagColor === 'orange' ? '#f57c00' : flagColor === 'green' ? '#388e3c' : ''"
    ></i>
    @if (registrant.getCommentCount() > 0) {
      <span
        class="tw-absolute -tw-top-1.5 -tw-right-1.5 tw-flex tw-h-[18px] tw-min-w-[18px] tw-items-center tw-justify-center tw-rounded-full tw-border-2 tw-border-white tw-bg-red-500 tw-px-1 tw-text-[10px] tw-font-semibold tw-text-white tw-shadow"
      >
        {{ registrant.getCommentCount() }}
      </span>
    }
  </button>
</app-dropdown>
